import React from 'react'
import Aos from 'aos'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import { Table } from 'react-bootstrap'
import '../../css/services.css'

const OtherMemberServices = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const OMSList = [
        {
            id: '१',
            title: '२० वर्ष पुरा भएको',
            savingRate: '५०,०००',
            rahatRate: '५०,०००'
        },
        {
            id: '२',
            title: '१५ वर्ष पुरा भइ २० ननाघेको',
            savingRate: '४०,०००',
            rahatRate: '४०,०००'
        },
        {
            id: '३',
            title: '१० वर्ष पुरा भइ १५ ननाघेको',
            savingRate: '३०,०००',
            rahatRate: '३०,०००'
        },
        {
            id: '४',
            title: '५ वर्ष पुरा भइ १० ननाघेको',
            savingRate: '२०,०००',
            rahatRate: '२०,०००'
        },
        {
            id: '५',
            title: '२ वर्ष पुरा भइ ५ ननाघेको',
            savingRate: '६,०००',
            rahatRate: '१०,०००'
        },
        {
            id: '६',
            title: 'सदस्य भइ २ वर्ष ननाघेको',
            savingRate: '६,०००',
            rahatRate: '६,०००'
        },
        {
            id: '७',
            title: 'क्र.स. १ देखि ६ सम्म नपर्ने सदस्य',
            savingRate: '',
            rahatRate: '५,०००'
        },
        {
            id: '८',
            title: 'सदस्यको पति वा पत्नीको हकमा',
            savingRate: '',
            rahatRate: '५,०००'
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right'>
                        <div className='heading1' data-aos='fade-right'>
                            <div className='h2'>
                                <h2>सदस्य राहत सेवा</h2><hr />
                            </div>
                        </div>
                        <div className='detail'>
                            <ul>
                                <li data-aos='fade-right'>१. प्रसुती राहत :</li>
                                <p data-aos='fade-right'>संस्थाका महिला सेयर सदस्य सुत्केरी भएमा प्रसुति राहत बापत पहिलो दुई सन्तानको हकमा रु. २,०००।–
                                    <br />नोट : प्रसुति राहत दावीका लागि निज सदस्यले नवजात शिशुको जन्म दर्ता प्रमाण पत्र वा अस्पतालको कागज शिशु जन्मिएको ६ महिना भित्र संस्थामा पेश गरी सक्नुपर्नेछ ।
                                </p>

                                <li data-aos='fade-right'>२. घातक रोग :</li>
                                <p data-aos='fade-right'>
                                    नेपाल सरकारले तोकेका तपसिलका घातक रोगहरू सदस्यहरूलाई लागेको आधिकारिक स्वास्थ्य संस्थाबाट प्रमाणित कागजात संस्थामा पेश गरेमा राहत स्वरूप रु.१०,०००।– प्रदान गरिनेछ ।
                                    <br /><b><u>तपसिल</u></b><br />Heart attack, Kidney failure, Cancer, Alzheimer, Parkinson, Head injury, Spinal injury, Sickle cell anemia, Liver damage, Paralysis, Brain Hemorrhage र Lungs Transplant
                                </p>

                                <li data-aos='fade-right'>३. प्राकृतिक विपत्ति :</li>
                                <p data-aos='fade-right'>बाढी, पहिरो, भूकम्प तथा आगलागीका कारण कुनै सेयर सदस्यहरूको वासस्थान पूर्ण रूपमा नष्ट भएमा त्यस्ता सेयर सदस्यहरूलाई राहत स्वरूप रु. १०,०००।– प्रदान गरिनेछ ।</p>

                                <li data-aos='fade-right'>४. सदस्य वा सदस्यको पति/पत्नी मृत्यु राहत :</li>
                                <p data-aos='fade-right'>सदस्य वा सदस्यको पति वा पत्नीको मृत्यु हुँदा वहाँको परिवारले राहत वापत तपसिल अनुसारको मृत्यु राहत रकम प्राप्त गर्नुहुन्छ ।</p>
                                <div className='rahat-img' data-aos='fade-right'>
                                    <div className='bg-white rounded shadow table-body'>
                                        <Table responsive striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>क्र.स.</th>
                                                    <th>सदस्य बनेको अवधि</th>
                                                    <th>बचत रकम</th>
                                                    <th>राहत रकम</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {OMSList.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td className='sn'>{item.id}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item.savingRate}</td>
                                                        <td>{item.rahatRate}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default OtherMemberServices